export default __webpack_public_path__ + "static/media/booking.be1de643.svg";